<template>
  <div>
    <div class="navgition-wrapper" v-if="navAreaList">
      <!-- 筛选栏目 -->
      <div class="selectList">
        <!-- 默认 -->
        <div class="cluster">
          <div class="left">
            地区分布:
          </div>
          <div class="right">
            <span class="expanded" v-show="navAreaList.length > 1" @click="handleShowFirMore($event)">更多</span>
          </div>
        
          <!--主体部分-->
         
          <div v-for="(itemArrs, index) of navAreaList" 
              :key="index" :name="index">
         
            <ul class="cluster-more" v-show =(!index)>
              <li v-for="(itemArr, indexChild) of itemArrs"
                :title="itemArr.value"
                :class="{'before-traggle': itemArr.subdata.length > 0 && overCurrentIndex === indexChild && overCurrentAreaRow == index, 'select' : overCurrentIndex === indexChild  && overCurrentAreaRow == index}"
                @click="handleAddAreaFir($event, itemArr.value)"
                @mouseover="handleMouseAreaFir($event, index, indexChild)"
                :key="indexChild" 
                :name="indexChild">
                  {{itemArr.value | ellipsis}}
                  <span v-if="itemArr.subdata.length > 0"></span>
              </li>
            </ul>
         
            <!-- 插入 -->
            <div class="insertItems" v-show="false">
              <ul class="ItemInsert clear" 
                  style="height: 36px;" 
                  v-for="(CountryArrs, index) of itemArrs"
                  :key="index"
                  :name="index"
                  
                  
                  v-show = "false"
                  >
                <li v-for="(countryArr, index) of CountryArrs.subdata"
                    :title="countryArr.value"
                    :key="index"
                    @click="handleAddAreaSec($event, countryArr.value)"
                    @mouseover="handleMouseAreaSec($event, index)"
                    :class="{selectSec : overAreaInsertCurrentIndex === index}"
                    >{{countryArr.value | ellipsis}}</li>
                <span class="insertExpand" @click="handleSecondMore($event)" @mouseover="handleMouseAreaSec($event, index)" v-show="CountryArrs.subdata.length > 11">更多</span>
              </ul>
            </div>
          </div>
         
        </div>
      </div>
    </div>
    
    <ContenCategory :queryCondition="queryCondition" :filterList="filterList"></ContenCategory>

  </div>
</template>

<script>
import $ from 'jquery'
import ContenCategory from '@/common/ContenCategory'
import {mapGetters} from 'vuex'
export default {
  name: 'Category',
  components: {
    ContenCategory
  },
  data () {
    return {
      province: '',
      county: '',
      resultData: {},
      queryCondition: [],
      total: 10,
      pageNum: 10,
      pageSize: 1,
      //name: 0
      Facelist: [],
      flag : true,
      titleFlag : true,
      filterList: [],
      overCurrentIndex: -1,
      overCurrentAreaRow: -1,
      overAreaInsertCurrentIndex: -1,
      filterSearchList: []
    }
  },
  methods: {
    // 展开一级分类更多
    handleShowFirMore (e) {
      var $this = $(e.target)
      $('.cluster > div:gt(2)').show(500)
      $(".cluster > div[name='0'] > ul").show(500);
      if(!this.titleFlag) {
        //收起是执行的逻辑
        $('.cluster > div:gt(2)').hide(500)
        var arrSecitem = $('.cluster > div:gt(2)')
        for(var i=0;i<arrSecitem.length;i++) {
          //arrSecitem.eq(i).children('div').last()
          $('.cluster > div:gt(2)').eq(i).children('div').last().hide(500)
          $('.cluster > div:gt(2)').eq(i).children('ul').last().children('li').removeClass("select")
          $('.cluster > div:gt(2)').eq(i).children('ul').last().children('li').children('span').removeClass("traggle")
        }
      }
      else {
        var arrSecitem = $('.cluster > div:gt(2)')
        for(var i=0;i<arrSecitem.length;i++) {
          $('.cluster > div:gt(2)').eq(i).children('ul').last().show(500)
        }
      }
      !this.titleFlag ? $this.text("更多") :  $this.text("收起")
      this.titleFlag = !this.titleFlag
    },
    handleMouseAreaFir(e, index, indexChild) {
      var $this = $(e.target)
      //$this.children().toggle();
      var name = $this.attr("name")
      var ulN =$this.parent().next().children('ul[name ='+name+']');
      var state = ulN.css("display"); // block none
      if ( state === "block") {
        //$this.parent().next().show();
        $this.parent().next().show();
        
        $this.parent().next().children('ul[name ='+name+']').toggle();
        $this.parent().next().toggle();
      }else {
        $this.parent().next().hide();
        $this.parent().next().children('ul[name ='+name+']').hide();
      }
      $this.parent().next().children('ul[name ='+name+']').siblings("ul").hide();
      $this.parent().next().children('ul[name ='+name+']').toggle();
      $('.insertItems').hide()
      $this.parent().next().show()
      //$this.parent().next().slideDown(500)
      $this.parent().next().children('ul[name ='+name+']').show()
      // 
      let lengthLi = $this.parent().next().children('ul[name ='+name+']').children().length
      if(lengthLi <= 1) {
        $this.parent().next().children('ul[name ='+name+']').hide();
        $this.parent().next().hide()
      }
      this.overCurrentIndex = indexChild
      this.overCurrentAreaRow =  $this.parent().parent().attr('name')
    },
    handleMouseAreaSec (e, index) {
      this.overAreaInsertCurrentIndex = index
    },
    //
    // 二级列表更多展开
    handleSecondMore(e) {
      var $this = $(e.target)
      var autoHeight = $this.parent().css("height", "auto").height();
      this.flag ? $this.parent().height("36px").animate({"height": autoHeight}, 300) :  $this.parent().height(autoHeight).animate({"height":"36px"}, 300)
      !this.flag ? $this.text("更多") :  $this.text("收起")
      this.flag = !this.flag
    },
    // 拼接查询条件
    async handleAddAreaSec(e, val) {
      if (await this.$loginAuthentication.intercept(0)) {
        let sortType = this.$route.query.sortType
        let pageNo = this.$route.query.pageNo
        var $this = $(e.target)
        var secNameIndex = $this.parent().attr('name')
        //.children('ul[name ='+secNameIndex+']').attr('title')
        var firTitleName = $this.parent().parent().prev().children('li').eq(secNameIndex).attr('title')
        // 过滤
        if (this.filterSearchList.length > 0) {
          this.filterSearchList.forEach( (item, index)=> {
            if(item.split(':')[1] == firTitleName) {
              //const newArrS = 'City:'+firTitleName + '#' + val
              const queryStr = firTitleName + '#' + val
              //this.filterSearchList.splice(index, 1 , newArrS)
              //this.filterSearchList.push ('City:' + val)
              this.$router.replace(
                {path:'category', 
                query: { City: queryStr, sortType: sortType, pageNo: 1},
                })
            }else {
              //this.filterSearchList = []
              //this.filterSearchList.push (`City:${firTitleName}#${val}`)
              const queryStr = `${firTitleName}#${val}`
              //this.filterSearchList.push ('Province:' + firTitleName)
              //this.filterSearchList.push ('City:' + val)
              this.$router.replace(
                {path:'category', 
                query: {City: queryStr, sortType: sortType, pageNo: 1},
                })
            }
        })
        }else {
          //this.filterSearchList.push ('Province:' + firTitleName)
          //this.filterSearchList.push ('City:' + val)
          const queryStr = `${firTitleName}#${val}`
          this.$router.replace(
            {path:'category', 
            query: {City: queryStr, sortType: sortType, pageNo: 1},
            })
        }
      }
    },
    async handleAddAreaFir (e, val) {
      if (await this.$loginAuthentication.intercept(0)) {
        let sortType = this.$route.query.sortType
        let pageNo = this.$route.query.pageNo
        //this.filterSearchList = []
        //this.filterSearchList.push ('Province:' + val)
        this.$router.replace(
          {path:'category', 
            query: {Province: val, sortType: sortType, pageNo: 1}
          })
      }
    }
  },
  created () {
    this.$store.dispatch('getNavArea')
  },
  computed: {
    ...mapGetters(['navAreaList'])
  },
  filters: {
    ellipsis(value) {
      if (!value) return;
      if (value.length > 5) {
        return value.slice(0, 5) + "...";
      }
      return value;
    }
  },
  watch: {
    // 动态监视路由query变化 //实时聚类
    $route: {
      handler(val) {
        this.$loginAuthentication.intercept(0);
      },
      deep: true
    }
  },
  mounted() {
    this.$loginAuthentication.intercept(0);
  },
}


</script>

<style lang="less" scoped>


.select 
  {
    background: url(~imgs/provice-select.png) no-repeat;
    background-size: 100% 100%;
  }
.selectList{
  width: 1200px;
  margin: 0 auto;
  //border-bottom: 1px dotted #e2d7d1;
  padding-bottom: 17px;
  color: #94491f;
  .cluster {
    width: 1200px;
    margin: 0 auto;
    padding-top: 10px;
    overflow: hidden;
    position: relative;
    ul {
      display: block;
      // width: 1100px;
       width: 1064px;
        li {
          text-align: center;
          font-size: 14px;
          height: 36px;
          line-height: 36px;
          width: 90px;
          color: #a31f24;
          float: left;
          cursor: pointer;
          // display: inline-block;
          white-space: nowrap;
          text-overflow: ellipsis;
          //overflow: hidden;
          display: inline-block;
        }
        .select {
          background: url(~imgs/provice-select.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    .right {
      width: 100px;
      float: right;
      height: 36px;
      text-align: center;
      line-height: 36px;  
      cursor: pointer;
      position: absolute;
      right: 0;
    }
    .center {
      width: 1000px;
      float: left;
      ul {
        height: 36px;
        overflow: hidden; // 11个元素
      }
    }
    .left {
      width: 100px;
      float: left;
      height: 36px;
      line-height: 36px;
      position: absolute;
    }
  }
  .insertExpand {
    position: absolute;
    top: 9px;
    right: -62px;
    font-size: 13px;
    }
  .expanded {
    font-size: 13px;
  }
  .insertItems {
    width: 1100px;
    display: inline-block;
    //top: 10px;
    position: relative;
    cursor: pointer;
  }
  .ItemInsert {
    margin-left: 100px;
    width: 1000px;
    overflow: hidden;
    background: #dfdbd9;
    //height: 36px;;
    //margin: 10px 0;
    padding-right: 100px;
    li {
      float: left;
      width: 90px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      font-size: 13px;
    }
  }
  .cluster-more {
    margin-left: 100px;
    width: 1000px;
    height: 36px;
    overflow: hidden;
    color: #a31f24;
    cursor: pointer;
    padding-bottom: 10px;
    li {
      position: relative;
      float: left;
      width: 90px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      
    }
    .before-traggle::after {
      position: absolute;
      content: '';
      top: 36px;
      left: 35px;
      border-right: 10px solid transparent;
      border-left: 10px solid transparent;
      border-bottom: 10px solid #dfdbd9;
    }
    
  }
}
.combination {
  .left {
    height: 30px;
    line-height: 30px;
    text-align: center;
    width: 100px;
    float: left;
    padding-top: 16px;
  }
  .center {
    width: 1100px;
    float: left;
    ul {
      float: left;
      display: block;
      padding-top: 14px;
        li {
          text-align: center;
          font-size: 16px;
          height: 36px;
          line-height: 36px;
          color: #b27350;
          float: left;
          padding: 0 10px;
        }
        .select {
          border: 1px solid #b27350;
        }
      }
    }
}
.left {
font-size: 16px;
color: #333;
}
.selectSec {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/category/Category.vue